import { Ico } from "@/assets/icons";
import { colors } from "@/components/Theme/colors";
import Button, { ButtonProps } from "@/shared/components/atoms/Button/Button";
import { FC, memo, ReactNode } from "react";

export interface ChannelFollowingButtonProps extends ButtonProps {
  isFollowing: boolean;
  isFollowLoading?: boolean;
  labels?: {
    follow?: string;
    following?: string;
  };
  children?: ReactNode;
}

const FIXED_HEIGHT = "40px";

const ChannelFollowingButton: FC<ChannelFollowingButtonProps> = memo(
  ({
    isFollowing,
    isFollowLoading,
    labels,
    children,
    borderRadius = "6px",
    w = "fit-content",
    isLoading: isLoadingProp,
    isDisabled: isDisabledProp,
    ...buttonProps
  }) => {
    const computedLabel = isFollowing
      ? labels?.following || "Seguido"
      : labels?.follow || "Seguir";

    const mergedIsDisabled = isDisabledProp ?? isFollowLoading;
    const isHiddenWhileLoading = Boolean(isFollowLoading);

    return (
      <Button
        leftIcon={
          isFollowing ? (
            <Ico.UserFollowingFilled
              fontSize="20px"
              color={colors.neutral[400]}
            />
          ) : (
            <Ico.UserFollow fontSize="20px" color="white" />
          )
        }
        borderRadius={borderRadius}
        colorScheme={"gray"}
        w={w}
        h={FIXED_HEIGHT}
        minH={FIXED_HEIGHT}
        lineHeight={FIXED_HEIGHT}
        spinnerPlacement="start"
        whiteSpace="nowrap"
        color={isFollowing ? colors.neutral[400] : "white"}
        isDisabled={mergedIsDisabled}
        isLoading={isLoadingProp}
        variant={isFollowing ? "colorscheme" : "primary"}
        opacity={isHiddenWhileLoading ? 0 : 1}
        visibility={isHiddenWhileLoading ? "hidden" : "visible"}
        pointerEvents={isHiddenWhileLoading ? "none" : "auto"}
        transform={isHiddenWhileLoading ? "translateY(4px)" : "translateY(0)"}
        transition="opacity 0.2s ease, transform 0.2s ease"
        {...buttonProps}
      >
        {children ?? computedLabel}
      </Button>
    );
  }
);

ChannelFollowingButton.displayName = "ChannelFollowingButton";

export default ChannelFollowingButton;
